import {DeleteOutlined} from '@ant-design/icons';
import {Button, Form, Tooltip, Input} from 'antd';
import {FormListFieldData} from 'antd/es/form/FormList';
import {StoreValue} from 'antd/es/form/interface';
import React, {FC} from 'react';

import styles from './foreign-submit-group-company-item.module.less';

interface IForeignSubmitGroupCompanyItem {
    conditionsFields: FormListFieldData[];
    conditionsListOperations: {
        add: (defaultValue?: StoreValue, insertIndex?: number) => void;
        remove: (index: number | number[]) => void;
    };
    areFieldsDisabled: boolean;
}

export const ForeignSubmitGroupCompanyItem: FC<IForeignSubmitGroupCompanyItem> = ({
    conditionsFields,
    conditionsListOperations,
    areFieldsDisabled,
}: IForeignSubmitGroupCompanyItem) => {
    const {remove, add} = conditionsListOperations;

    return (
        <>
            {conditionsFields.map((conditionField) => (
                <section
                    className={styles['foreign-group-company-item__condition-row']}
                    key={conditionField.key}
                >
                    <div>
                        <div className="d-flex gap-2 align-items-end">
                            <Form.Item
                                label="Регистрационный номер иностранной материнской компании в стране регистрации (инкорпорации)"
                                name={[conditionField.name, 'regNumber']}
                                className={styles['foreign-group-company-item__condition-row--width']}
                                rules={[{max: 100, message: 'Длина должна быть не более 100 символов'}]}
                            >
                                <Input disabled={areFieldsDisabled} />
                            </Form.Item>

                            <Form.Item
                                label="Код страны регистрации иностранной материнской компании"
                                rules={[{max: 3, required: true, message: 'Длина должна быть не более 3 символов'}]}
                                name={[conditionField.name, 'countryCode']}
                                className={styles['foreign-group-company-item__condition-row--width']}
                            >
                                <Input
                                    onKeyPress={(e) => {
                                        if (!/[0-9]/.test(e.key)) {
                                            e.preventDefault();
                                        }
                                    }}
                                    disabled={areFieldsDisabled}
                                />
                            </Form.Item>
                        </div>

                        <div className="d-flex align-items-end">
                            <Form.Item
                                label="Наименование иностранной материнской компании группы компаний (холдинга)"
                                rules={[{max: 250, required: true, message: 'Длина должна быть не более 250 символов'}]}
                                name={[conditionField.name, 'name']}
                                className={styles['foreign-group-company-item__name--width']}
                            >
                                <Input disabled={areFieldsDisabled} />
                            </Form.Item>

                            <Form.Item label={<>&nbsp;</>}>
                                <Tooltip
                                    title="Удалить условие"
                                    placement="right"
                                    mouseEnterDelay={0.8}
                                >
                                    <Button
                                        type="default"
                                        className="btn-only-icon"
                                        disabled={areFieldsDisabled}
                                        onClick={() => {
                                            remove(conditionField.name);
                                            // Если удаляется последний элемент, то мы добавляем новый
                                            if (conditionsFields.length === 1) add();
                                        }}
                                    >
                                        <DeleteOutlined />
                                    </Button>
                                </Tooltip>
                            </Form.Item>
                        </div>
                    </div>
                </section>
            ))}
        </>
    );
};
